<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const statVariants = cva(
  'group/stat flex flex-col justify-between gap-1 text-gray-600 group-data-[variant=joined]/stat-group:items-center group-data-[variant=joined]/stat-group:text-center',
  {
    variants: {
      variant: {
        inline: '',
        card: 'rounded-lg border border-neutral-600 bg-white p-4',
      },
      align: {
        left: 'items-start text-left',
        center: 'items-center text-center',
        right: 'items-end text-right',
      },
    },
    defaultVariants: {
      variant: 'inline',
      align: 'left',
    },
  },
)

export type StatVariants = VariantProps<typeof statVariants>
</script>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  variant?: StatVariants['variant']
  align?: StatVariants['align']
}>()
</script>

<template>
  <div
    data-slot="stat"
    :data-variant="variant ?? 'inline'"
    :data-align="align ?? 'left'"
    :class="cn(statVariants({ variant, align }), props.class)"
  >
    <slot />
  </div>
</template>
